import React from "react"

const CustomerRatingPanel = ({ children }) => {
  return (
    <section className="customer-ratings mt-16 mb-16 container-fluid">
      {children}
    </section>
  )
}

export default CustomerRatingPanel
